import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>v1.0 - {new Date().getFullYear()} © all rights reserved <a href="https://keepsmiles.in">Keepsmiles.in</a>.</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">Design &amp; Develop by <a href="http://catchysystem.com">catchysystem.com</a></div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
